import React from "react";
import classNames from "classnames";
import "./PanelInvisible.scss";

const PanelInvisible = props => {
    let mainClassName = classNames({
        "panel-invisible-container": true,
        "panel-invisible-grid": true,
    });
    if (props.className) mainClassName += ` ${props.className}`;

    return <div className={mainClassName}>{props.children}</div>;
};

export default PanelInvisible;
